// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1cU4m","list":"PatternAutocomplete_list__1-dVq"};